import React from "react";
import { clientAccounts, workPipelines } from "../../../../data/workspaceData";
import { SectionHeader } from "../../common/WorkspaceChrome";

export function CrmView() {
  return (
    <>
    <section className="split-layout">
      <div className="panel">
        <SectionHeader
          eyebrow="CRM"
          title="Leads, clients, contacts, projects, invoices, meetings, and tickets"
          text="CRM stays lightweight but connected to delivery, follow-ups, BDE/BDA ownership, and commission reporting."
        />
        <div className="crm-list">
          {clientAccounts.map((account) => (
            <article key={account.name}>
              <div>
                <strong>{account.name}</strong>
                <span>{account.stage}</span>
              </div>
              <p>{account.next}</p>
              <small>{account.owner}</small>
              <em>{account.value}</em>
            </article>
          ))}
        </div>
      </div>
      <div className="panel">
        <SectionHeader
          eyebrow="Pipeline"
          title="Lead to client to project"
          text="Won leads create clients, project shells, onboarding checklists, kickoff meetings, and payment tracking."
        />
        <div className="pipeline-grid single-column">
          {workPipelines.slice(2).map((pipeline) => (
            <article className="pipeline-card" key={pipeline.name}>
              <h3>{pipeline.name}</h3>
              <p>{pipeline.purpose}</p>
              <div className="stage-row">
                {pipeline.stages.map((stage) => (
                  <span key={stage}>{stage}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
    </>
  );
}
